import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor: string;
}

interface ProductOfInterest {
  idProduto: string;
  nomeProduto: string;
  idBandeira: string;
  nomeBandeira: string;
  fase: string;
  fotoProduto: string;
}

export interface DataResponse {
  qtdOfertaAtiva?: any;
  idLeadCorretor: string;
  idCorretorLead: string;
  idLead: string;
  codigoLeadCrm2013: string;
  nomeLead: string;
  telefone1: string;
  telefone2: string;
  telefone3: string;
  codigoTelefonePrincipal: number | null;
  email1: string;
  email2: string;
  email3: string;
  codigoEmailPrincipal: number | null;
  idTemperaturaLead: string;
  temperaturaLead: "Frio" | "Morno" | "Quente" | undefined;
  idOrigemLead: string;
  origemLead: string;
  idCanal: string;
  canal: string;
  idProdutoOrigem: string;
  produtoOrigem: string;
  idEtapaLead: string;
  etapaLead: string;
  dataCriacao: string;
  dataUltimaAtualizacao: string;
  observacaoCliente: string;
  farolAtualizacao: "amarelo" | "verde" | "vermelho" | undefined;
  identificaCliente: boolean | null;
  produtosInteresse: ProductOfInterest[];
  emailOrigemInformado: boolean;
  telefoneOrigemInformado: boolean;
  etiqueta?: { id: string; nome: string; cor: string } | null;
  visitou?: boolean;
  subEtapaLead: string;
  idSubEtapaLead: string;
  compartilhado?: boolean;
  proprio?: boolean;
}

export function useDadosBasicosV2(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const DADOS_BASICOSV2 = `${leadsWebEnviroment}/commom/leads/dados-basicos/v2/${props.idLeadCorretor}`;
    const response = await instance.get(DADOS_BASICOSV2);

    return response?.data?.data?.dataResponse as DataResponse;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar dados do basicos lead. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
